import ApiClient from './ApiClient';

class DeliveryDriversAPI extends ApiClient {
  constructor() {
    super('delivery_drivers', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(driverId) {
    return axios.get(`${this.url}/${driverId}`);
  }

  create(data) {
    return axios.post(this.url, { delivery_driver: data });
  }

  update(driverId, data) {
    return axios.patch(`${this.url}/${driverId}`, { delivery_driver: data });
  }

  delete(driverId) {
    return axios.delete(`${this.url}/${driverId}`);
  }

  toggleActive(driverId) {
    return axios.post(`${this.url}/${driverId}/toggle_active`);
  }
}

export default new DeliveryDriversAPI();
